import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { $orgRole } from '@nx-frontend/shared/store/org-role';
import { $isCustomizerMode } from '@nx-frontend/shared/store/portal-app';
import { $pageInfo } from '@nx-frontend/shared/store/portal-page';
import { $portalAIAssistantSettings } from '@nx-frontend/shared/store/portal-settings';
import { $unleashFlags } from '@nx-frontend/shared/store/unleash-flags';
import { UnleashFeatures } from '@nx-frontend/shared/types';
import { getIsMobile } from '@nx-frontend/shared/utils';

export function useIsAIAssistantEnabledForPortal() {
  const isMobile = useMemo(() => getIsMobile(), []);
  const [unleashFlags, orgRole, portalAIAssistantSettings, isCustomizerMode, pageInfo] = useUnit([
    $unleashFlags,
    $orgRole,
    $portalAIAssistantSettings,
    $isCustomizerMode,
    $pageInfo,
  ]);

  const aiAssistsantEnabledConditions =
    pageInfo.visible && !isMobile && !isCustomizerMode && unleashFlags[UnleashFeatures.AI_ASSISTANT_IN_PORTALS];
  if (!aiAssistsantEnabledConditions) {
    return false;
  }

  if (orgRole === 'visitor' && !portalAIAssistantSettings.availability?.anyone) {
    return false;
  }

  if (portalAIAssistantSettings.availability?.loggedIn) {
    return true;
  }

  return false;
}
